import { render, staticRenderFns } from "./SetupStepFaq.vue?vue&type=template&id=58752cb9&"
import script from "./SetupStepFaq.vue?vue&type=script&lang=js&"
export * from "./SetupStepFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports